import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/views/Home.vue';
import DictEntries from '@/views/DictEntries.vue';
import Search from '@/views/Search.vue';
import DefaultLayout from '@/views/DefaultLayout.vue';
import Transcription from '@/views/Transcription.vue';
import AdminIndex from '@/components/admin/index.vue';
import General from '@/components/admin/General.vue';
import Entries from '@/components/admin/Entries.vue';
import Collection from '@/views/Collection.vue';
import TrscView from '@/components/transcription/TrscView.vue';
import TrscBib from '@/components/transcription/TrscBib.vue';
import TrscDownload from '@/components/transcription/TrscDownload.vue';
import TrscEditor from '@/components/transcription/TrscEditor.vue';
import AnnotationList from '@/components/transcription/AnnotationList.vue';
import Projects from '@/views/Projects.vue';
import Project from '@/views/Project.vue';
import ProjectIndex from '@/components/projects/ProjectIndex.vue';
import TrscHistory from './components/transcription/TrscHistory.vue';
import Learn from './views/Learn.vue';
import About from './views/About.vue';
import Introduction from './components/about/SiteInfo.vue';
import Guideline from './components/about/Guideline.vue';
import Characters from './components/about/Characters.vue';
import License from './components/about/License.vue';
import Credit from './components/about/Credit.vue';
import Privacy from './views/Privacy.vue';
import TrscHelp from './components/transcription/TrscHelp.vue';
import Help from './views/Help.vue';
import Manual from './components/help/Manual.vue';
import Questions from './components/help/Questions.vue';

Vue.use(Router);

export default new Router({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			component: DefaultLayout,
			children: [
				{
					path: '',
					name: 'home',
					component: Home
				},
				{
					path: 'learn',
					name: 'learn',
					component: Learn
				},
				{
					path: 'help',
					component: Help,
					children: [
						{
							path: 'manual',
							name: 'help.manual',
							component: Manual
						},
						{
							path: 'questions',
							name: 'help.questions',
							component: Questions
						}
					]
				},
				{
					path: 'about',
					component: About,
					children: [
						{
							path: 'introduction',
							name: 'introduction',
							component: Introduction
						},
						{
							path: 'guideline',
							name: 'guideline',
							component: Guideline
						},
						{
							path: 'characters',
							name: 'characters',
							component: Characters
						},
						{
							path: 'license',
							name: 'license',
							component: License
						},
						{
							path: 'credit',
							name: 'credit',
							component: Credit
						},
						{
							path: 'privacy',
							name: 'privacy',
							component: Privacy
						}
					]
				},
				{
					path: 'projects',
					name: 'projects',
					component: Projects
				},
				{
					path: 'projects/:projectId',
					component: Project,
					children: [
						{
							path: 'info',
							name: 'project-index',
							component: ProjectIndex
						},
						{
							path: 'collections/:collectionId',
							name: 'project-collection',
							component: Collection
						}
					]
				},
				{
					path: '/search',
					name: 'search',
					component: Search
				},
				{
					path: '/dict',
					name: 'dict',
					component: DictEntries
				},
				{
					path: 'collection/:collectionId',
					name: 'collection',
					component: Collection
				},
				{
					path: 'admin/:id',
					component: AdminIndex,
					children: [
						{
							path: '/',
							name: 'admin.general',
							component: General
						},
						{
							path: 'entries',
							name: 'entries',
							component: Entries
						},
						{
							path: 'members',
							name: 'members'
						},
						{
							path: 'progress',
							name: 'progress'
						}
					]
				}
			]
		},
		{
			path: '/transcription/:entryId/:page',
			component: Transcription,
			children: [
				{
					path: '',
					name: 'transcription.view',
					component: TrscView,
					beforeEnter: (from, to, next) => {
						next({ query: { ref: from.fullPath } });
					}
				},
				{
					path: 'edit',
					name: 'transcription.edit',
					component: TrscEditor
				},
				{
					path: 'annotations',
					name: 'transcription.annotations',
					component: AnnotationList
				},
				{
					path: 'history',
					name: 'transcription.history',
					component: TrscHistory
				},
				{
					path: 'bib',
					name: 'transcription.bib',
					component: TrscBib
				},
				{
					path: 'help',
					name: 'transcription.help',
					component: TrscHelp
				},
				{
					path: 'dl',
					name: 'transcription.dl',
					component: TrscDownload
				}
			]
			//      component: Transcription,
		},
		{
			path: '/about',
			name: 'about',
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
		}
	]
});
